module.exports = __webpack_public_path__ + "static/img/img2.09c6d65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity202110/img2.png
// module id = DQw2
// module chunks = 0